export const OMR_BADGE_IMAGE_SRC =
    'https://fiverr-res.cloudinary.com/image/upload/f_png,q_auto/v1/attachments/generic_asset/asset/92c98b4c5df456e32bf248fcaa316df5-1785933804961/omrBadge26Q3.svg';
